// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitCustomControlCalendarToggle-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendarToggle.mobile.scss
 ** module id = 935
 ** module chunks = 1
 **/